/**
 * The side panels finance records open in, inside a conversation (owner 2026-10-31). Each is named after the card
 * `entity` it opens and renders the record's own screen under the policy its route requires:
 *  - `strategy` (`strategy_detail` / `strategy_list`, id `def:<definition id>`): the strategy workbench;
 *  - `backtest` (the backtest skill's cards, id `run:<run id>`): the run's report;
 *  - `portfolio`: the portfolio's page.
 * A backtest has no "Open in detailed view": the Strategy Tester opens a run only through its strategy.
 */
import type { PanelTypeDefinition } from '../../../client/src/components/context-panel/registry.js';
import {
  type EntityPanelBodyProps,
  lazyEntityPanel,
} from '../../../client/src/components/context-panel/entity-panel-render.js';
import { definitionIdOf, runIdOf } from './pages/strategies/strategy-entity-ids.js';

export const financePanelTypes: PanelTypeDefinition[] = [
  {
    type: 'strategy',
    mode: 'viewer',
    label: 'Strategy',
    policy: 'CanManageStrategies',
    detailHref: (id) => `/finance/strategies/${definitionIdOf(id)}`,
    render: lazyEntityPanel(() =>
      import('./pages/strategies/StrategyEntityPanel.js').then((m) => ({ default: m.StrategyEntityPanel })),
    ),
  },
  {
    type: 'backtest',
    mode: 'viewer',
    label: 'Backtest',
    policy: 'CanViewStrategyResults',
    render: lazyEntityPanel(() =>
      import('./pages/strategies/detail/runs/RunDetail.js').then((m) => ({
        default: ({ id, onClose }: EntityPanelBodyProps) => <m.RunDetail runId={runIdOf(id)} onBack={onClose} />,
      })),
    ),
  },
  {
    type: 'portfolio',
    mode: 'viewer',
    label: 'Portfolio',
    policy: 'CanViewPortfolio',
    detailHref: (id) => `/finance/portfolios/${id}`,
    render: lazyEntityPanel(() =>
      import('./pages/PortfolioDetail.js').then((m) => ({
        default: ({ id }: EntityPanelBodyProps) => <m.PortfolioDetailPage id={id} />,
      })),
    ),
  },
];
